import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { agency } from "../api";
import { HealthBadge } from "../components/HealthScore";

export default function AgencyPortfolio() {
  const [portfolio, setPortfolio] = useState(null);
  const [clients, setClients] = useState([]);
  const [err, setErr] = useState(null);

  useEffect(() => {
    Promise.all([agency.portfolio(), agency.listClients()])
      .then(([p, cs]) => { setPortfolio(p); setClients(cs); })
      .catch((e) => setErr(e?.response?.data?.detail || e.message));
  }, []);

  if (err) return <div className="page"><div className="error-box">{err}</div></div>;
  if (!portfolio) return <div className="page"><p className="subtle">Loading…</p></div>;

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h1>Portfolio</h1>
          <div className="subtle">
            {portfolio.active_clients} active • avg health {portfolio.average_health_score ?? "—"}
            {" • "}{portfolio.open_recommendations_count} open recommendations
          </div>
        </div>
        <Link to="/onboard"><button>Onboard a client</button></Link>
      </div>

      {portfolio.needs_attention.length > 0 && (
        <section style={{ marginBottom: 28 }}>
          <h2>Needs attention</h2>
          <div className="client-grid">
            {portfolio.needs_attention.map((c) => <ClientCard key={c.id} c={c} />)}
          </div>
        </section>
      )}

      <section>
        <h2>All clients</h2>
        {clients.length === 0 ? (
          <div className="empty">No clients yet — onboard your first.</div>
        ) : (
          <div className="client-grid">
            {clients.map((c) => <ClientCard key={c.id} c={c} />)}
          </div>
        )}
      </section>
    </div>
  );
}

function ClientCard({ c }) {
  return (
    <Link to={`/clients/${c.id}`} className="client-card">
      <div className="name">{c.name}</div>
      <div className="meta">{c.industry || "—"} • {c.location || "—"}</div>
      <div className="row">
        <HealthBadge score={c.health_score} />
        {c.alert_count > 0 && <span className="tag high">{c.alert_count} alerts</span>}
      </div>
      <div className="badges">
        <span className="tag">{c.onboarding_status}</span>
        {c.last_narrative_at && (
          <span className="tag">narrative {new Date(c.last_narrative_at).toLocaleDateString()}</span>
        )}
      </div>
    </Link>
  );
}
